// Client-safe hata takibi — "use client" graph'ındaki dosyalar burayı kullanır.
//
// `sentry.ts` (server) `posthog-node` içerir ve Turbopack ile client chunk'a
// gömülemez ("chunking context does not support external modules (node:fs)").
// Bu dosya bilinçli olarak şunları İÇERMEZ:
// - `posthog-node` (server-only)
// - `@/lib/log` (sentry.ts'e bağımlıydı — cycle olurdu)
// Sadece isomorphic `@sentry/nextjs` SDK'sı kullanılır.

import * as Sentry from "@sentry/nextjs";

export { SENTRY_FALLBACK_DSN, resolveSentryDsn, hasSentry } from "@/lib/sentry-shared";
import { hasSentry } from "@/lib/sentry-shared";

/** İstemci hata raporu — Sentry DSN yoksa sessiz (dev'de console). */
export function captureError(err: unknown, context?: Record<string, string>): void {
  if (!hasSentry()) {
    if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
      const message = err instanceof Error ? `${err.name}: ${err.message}` : String(err);
      console.error(`[sentry-fallback][${context?.route ?? "client"}] ${message}`);
    }
    return;
  }
  try {
    if (typeof Sentry.captureException === "function") {
      Sentry.captureException(err, { tags: context });
      void Sentry.flush?.(1000);
    }
  } catch {
    // Sentry SDK hatası asla UI'ı patlatmasın
  }
}
